import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from '../ServicesSection.module.scss';
import { CreditDeleteButton } from './CreditDeleteButton';
import CreditSwitch from './CreditSwitch';
export default function CreditBillingItem(props) {
    const { name, costDisplay, id, isPaused, index, agreement, disabled, tooltipTitle, compact, onBeforeRemove, onRefresh } = props;
    const { t: sectionTexts } = useLocaleKeys('billingHub.billingControlSections');
    const deleteButton = /*#__PURE__*/ _jsx(CreditDeleteButton, {
        chargeId: id,
        agreementId: agreement.id,
        disabled: disabled,
        tooltipTitle: tooltipTitle,
        onRefresh: onRefresh,
        onBeforeConfirm: onBeforeRemove,
        testId: "billing-control-credit-".concat(index, "-delete"),
        showLabel: compact
    });
    return /*#__PURE__*/ _jsxs("li", {
        "data-testid": "service-".concat(index),
        className: styles.serviceBox,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.serviceDescription,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: "name",
                        children: name
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.cost,
                        children: /*#__PURE__*/ _jsx(Typography, {
                            testId: "cost",
                            variant: "paragraph2",
                            skin: "secondary",
                            children: compact ? "".concat(costDisplay, " \xb7 ").concat(sectionTexts.credit()) : costDisplay
                        })
                    }),
                    compact && deleteButton
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.lineItemAction,
                children: [
                    /*#__PURE__*/ _jsx(CreditSwitch, {
                        testId: "billing-control-credit-".concat(index, "-switch"),
                        chargeId: id,
                        agreementId: agreement.id,
                        disabled: disabled,
                        tooltipTitle: tooltipTitle,
                        isPaused: isPaused,
                        onRefresh: onRefresh
                    }),
                    !compact && deleteButton
                ]
            })
        ]
    });
}
